import React from "react";
const DistanceDiv = () => (
  
 <div className="distance_div">

 </div>
  );
  
  export default DistanceDiv;